<template>
    <div v-if="dataIsVisible" class="c-action-button">
        <b-button @click="onClick" :class="buttonClass"><i v-if="iconClass!==''" :class="iconClass"></i>{{label}}</b-button>
        <br/>
        <small class="form-text text-muted">{{description}}</small>
    </div>
</template>


<script>
    import Request from './Request'
    export default {
        name: 'ActionButton',
        components: {
            Request
        },
        props: {
            options: {
                type: Object,
                default: function() {
                    return {
                        showAlert: true,
                        blockOnProcessing: true,
                        blockTransparent: false,
                        blockImg: '',
                        blockSpinner: 'wave'
                    }
                }
            },
            label: {
                type: String,
                default: ''
            },
            buttonClass: {
                type: String,
                default: 'btn btn-light'
            },
            iconClass: {
                type: String,
                default: ''
            },
            description: {
                type: String,
                default: ''
            },
            _isVisible: {
                type: Boolean,
                default: true
            }
        },
        watch: {
        },
        computed: {
            isVisible: {
                set(val) {
                    this.dataIsVisible = val
                },
                get() {
                    return this.dataIsVisible
                }
            }
        },
        mounted() {
            this.dataIsVisible = this._isVisible
        },
        data: () => {
            return {
                Core: window.Core,
                Mantle: window.Mantle,
                dataIsVisible: true
            }
        },
        methods: {
            onClick() {
                this.$emit('onClick')
            }
        }
    }
</script>
